export default __webpack_public_path__ + "static/media/grease.275646f7.png";